// extracted by mini-css-extract-plugin
export var active = "_2q-2";
export var highlight = "_2q-1";
export var highlightLayer = "_2q-0";
export var issuePopover = "_2q-3";
export var statusIcon = "_2q-4";